/* Ayudate · Sesión del panel de estudiante
   Mismo patrón que lib/sesionTutor.js: el token de login vive en
   localStorage, no en memoria, y el servidor es la única fuente de verdad
   sobre si sigue siendo válido (ver COL_CREDENCIALES_ESTUDIANTE.sessionExpiracion
   en apps-script.gs) — esto es solo dónde vive del lado del navegador. */

const CLAVE = "ayudate_sesion_estudiante";

export function guardarSesionEstudiante(token, correo) {
  localStorage.setItem(CLAVE, JSON.stringify({ token, correo }));
}

export function leerSesionEstudiante() {
  try {
    const cruda = localStorage.getItem(CLAVE);
    if (!cruda) return null;
    const s = JSON.parse(cruda);
    return s?.token ? s : null;
  } catch {
    return null;
  }
}

export function borrarSesionEstudiante() {
  localStorage.removeItem(CLAVE);
}
